import { render } from "./MoreDetailsRoster7Screen.vue?vue&type=template&id=30c93e72&scoped=true"
import script from "./MoreDetailsRoster7Screen.vue?vue&type=script&lang=js"
export * from "./MoreDetailsRoster7Screen.vue?vue&type=script&lang=js"

import "./MoreDetailsRoster7Screen.vue?vue&type=style&index=0&id=30c93e72&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-30c93e72"]])

export default __exports__